import { schema } from "normalizr";

const AttendanceSchema = new schema.Entity("attendances");
const AttendanceArraySchema = new schema.Array(AttendanceSchema);

export { 
  AttendanceSchema,
  AttendanceArraySchema
};